<template>
  <button class="button notification-activity_button" @click="emit('action')">
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
const emit = defineEmits(['action']);
</script>
